import React from 'react';
import { useVariantCopy } from './useVariantCopy';

// Split out of variant/PlatformAndFeatures so these sit under the pricing
// cards — the "how it works" detail reads better once a price is on screen.
const FeatureCards = () => {
	const L = useVariantCopy();

	return (
		<section className="stripe-section--gradient pb-10 md:pb-16">
			<div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
			{/* Feature Cards */}
			<div className="mt-10 md:mt-16 max-w-5xl mx-auto">
				<div className="text-center mb-6 md:mb-8">
					<span className="inline-block px-3 py-1 md:px-4 md:py-1.5 bg-instagram text-white text-xs md:text-sm font-semibold rounded-full">{L.header.platformLabel}</span>
				</div>
				<div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
					{/* Follower Growth Card */}
					<div className="group relative bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-gray-100 hover:shadow-xl hover:border-instagram transition-all duration-300">
						<div className="absolute inset-0 bg-gradient-to-br from-pink-50 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
						<div className="relative">
							<div className="inline-flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-xl bg-instagram text-white mb-4 md:mb-6">
								<i className="fa-solid fa-seedling text-xl md:text-2xl"></i>
							</div>
							<h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">{L.header.card1Title}</h3>
							<p className="text-sm md:text-base text-gray-600 mb-4 md:mb-6">{L.header.card1Sub}</p>

							<ul className="space-y-3 md:space-y-4">
								<li className="flex items-start gap-3">
									<div className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full bg-pink-100 flex items-center justify-center mt-0.5">
										<i className="fa-solid fa-crosshairs text-instagram text-xs"></i>
									</div>
									<span className="text-sm md:text-base text-gray-700">{L.header.card1Items[0]}</span>
								</li>
								<li className="flex items-start gap-3">
									<div className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full bg-pink-100 flex items-center justify-center mt-0.5">
										<i className="fa-solid fa-wand-sparkles text-instagram text-xs"></i>
									</div>
									<span className="text-sm md:text-base text-gray-700">{L.header.card1Items[1]}</span>
								</li>
								<li className="flex items-start gap-3">
									<div className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full bg-pink-100 flex items-center justify-center mt-0.5">
										<i className="fa-solid fa-shield-halved text-instagram text-xs"></i>
									</div>
									<span className="text-sm md:text-base text-gray-700">{L.header.card1Items[2]}</span>
								</li>
								<li className="flex items-start gap-3">
									<div className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full bg-pink-100 flex items-center justify-center mt-0.5">
										<i className="fa-solid fa-bolt text-instagram text-xs"></i>
									</div>
									<span className="text-sm md:text-base text-gray-700">{L.header.card1Items[3]}</span>
								</li>
							</ul>
						</div>
					</div>

					{/* Growth Tools Card */}
					<div className="group relative bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-gray-100 hover:shadow-xl hover:border-instagram transition-all duration-300">
						<div className="absolute inset-0 bg-gradient-to-br from-pink-50 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
						<div className="relative">
							<div className="inline-flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-xl bg-instagram text-white mb-4 md:mb-6">
								<i className="fa-solid fa-wand-magic-sparkles text-xl md:text-2xl"></i>
							</div>
							<h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">{L.header.card2Title}</h3>
							<p className="text-sm md:text-base text-gray-600 mb-4 md:mb-6">{L.header.card2Sub}</p>

							<ul className="space-y-3 md:space-y-4">
								<li className="flex items-start gap-3">
									<div className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full bg-pink-100 flex items-center justify-center mt-0.5">
										<i className="fa-solid fa-brain text-instagram text-xs"></i>
									</div>
									<span className="text-sm md:text-base text-gray-700">{L.header.card2Items[0]}</span>
								</li>
								<li className="flex items-start gap-3">
									<div className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full bg-pink-100 flex items-center justify-center mt-0.5">
										<i className="fa-solid fa-chart-simple text-instagram text-xs"></i>
									</div>
									<span className="text-sm md:text-base text-gray-700">{L.header.card2Items[1]}</span>
								</li>
								<li className="flex items-start gap-3">
									<div className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full bg-pink-100 flex items-center justify-center mt-0.5">
										<i className="fa-solid fa-magnifying-glass-chart text-instagram text-xs"></i>
									</div>
									<span className="text-sm md:text-base text-gray-700">{L.header.card2Items[2]}</span>
								</li>
								<li className="flex items-start gap-3">
									<div className="flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full bg-pink-100 flex items-center justify-center mt-0.5">
										<i className="fa-solid fa-video text-instagram text-xs"></i>
									</div>
									<span className="text-sm md:text-base text-gray-700">{L.header.card2Items[3]}</span>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			</div>
		</section>
	);
};

export default FeatureCards;
